import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["defaultText", "copiedText"]
  static values = { html: String, text: String }

  async copy() {
    try {
      if (navigator.clipboard?.write && typeof ClipboardItem !== "undefined") {
        const item = new ClipboardItem({
          "text/html": new Blob([this.htmlValue], { type: "text/html" }),
          "text/plain": new Blob([this.textValue], { type: "text/plain" })
        })
        await navigator.clipboard.write([item])
      } else {
        await navigator.clipboard.writeText(this.textValue)
      }

      this.showCopied()
    } catch (error) {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(this.textValue)
          this.showCopied()
          return
        } catch {
          // Keep the original error below for local diagnostics.
        }
      }

      console.error("Failed to copy rich text:", error)
    }
  }

  showCopied() {
    this.defaultTextTarget.classList.add("hidden")
    this.copiedTextTarget.classList.remove("hidden")

    setTimeout(() => {
      this.defaultTextTarget.classList.remove("hidden")
      this.copiedTextTarget.classList.add("hidden")
    }, 2000)
  }
}
